<template>
  <div class="auth-form-container">
    <Logo />
    <LoginForm />
    <p class="signup-link">
      <router-link to="/signup"
        >Not an account yet ? Sign up to Guesterix !</router-link
      >
    </p>
    <p class="signup-link">
      <router-link to="/password_reset">Reset your password</router-link>
    </p>
  </div>
</template>

<script>
import LoginForm from "@/components/molecules/LoginForm";
import Logo from "@/components/atoms/Logo";

export default {
  components: { LoginForm, Logo },
};
</script>

<style scoped>
.auth-form-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
}
</style>